(function(){

	"use strict";

	var debug = false;
	var cartCookie;
	var isCalculating = false;
	
	if (typeof ZipCodeManager === 'undefined') {
		console.error('ZipCodeManager not found. Please include zipcode-manager.js before get-estimates-product.js');
		return;
	}

  var shippingCalcExist = document.querySelector('.shipping-calc-wrapper');
	if(shippingCalcExist) return;

	var productSection = document.querySelector('.shopping-calculator-action');
	if(!productSection){ log('Could not find the element'); return }

	var productSelect = document.querySelector('product-form-component input[name="id"]');
	if(!productSelect){ log('Could not find the main select element'); return }

	var shippingMessage = document.createElement('p');
	shippingMessage.className = 'shipping-message';
	var shippingCountry = document.createElement('select');
	var shippingProvince = document.createElement('select');
	var shippingZip = document.createElement('input');

	var initFields = function(){

		var countries = ['United States'];
		for (var i = 0; i < countries.length; i++) {
			shippingCountry.add(new Option(countries[i], countries[i], i===0));
		};
		shippingCountry.name = 'shipping_address[country]';

		shippingProvince.name = 'shipping_address[province]';

		shippingZip.type = 'text';
		shippingZip.name = 'shipping_address[zip]';
    shippingZip.value = '';
    shippingZip.placeholder = 'Enter your zip code';

		var shippingCalcWrapper = document.createElement('div');
		shippingCalcWrapper.className = 'shipping-calc-wrapper';

		var shippingCalcButton = document.createElement('button');
		shippingCalcButton.innerText = 'Calculate';
		shippingCalcButton.className = 'button shippingCalcButton';
		shippingCalcButton.onclick = function(){
			var zipCode = shippingZip.value;
			if (!ZipCodeManager.isValidZipCode(zipCode)) return false;
			var storedZip = ZipCodeManager.getStoredZipCode();
			if (zipCode !== storedZip) {
				ZipCodeManager.updateZipCode(zipCode);
			} else {
				try { localStorage.removeItem('shipping_rates_v2_' + zipCode); } catch(e) {}
				calculateShipping();
			}
			return false;
		};

		var labelNames = ['Zip Code'];
		var labels = [];
		for (var i = 0; i < labelNames.length; i++) {
			var label = document.createElement('label');
			label.innerText = labelNames[i];
			labels.push(label);
		};

		shippingCalcWrapper.appendChild(shippingZip);
		shippingCalcWrapper.appendChild(shippingCalcButton);
		shippingCalcWrapper.appendChild(shippingMessage);

		productSection.appendChild(shippingCalcWrapper);

		ZipCodeManager.onZipCodeUpdate(function(data) {
			if (data.zipCode) {
				shippingZip.value = data.zipCode;
				updateGrowingZoneDisplay(data.zone, data.zipCode);
				
				var cachedRates = ZipCodeManager.getStoredShippingRates(data.zipCode);
				if (cachedRates) {
					renderShippingRates(cachedRates, data.zipCode);
				} else {
					calculateShipping();
				}
			}
		});

		var storedZip = ZipCodeManager.getStoredZipCode();
		var storedZone = ZipCodeManager.getStoredGrowingZone();
		
		if (storedZip && ZipCodeManager.isValidZipCode(storedZip)) {
		  shippingZip.value = storedZip;
		  updateGrowingZoneDisplay(storedZone, storedZip);
		  
		  var cachedRates = ZipCodeManager.getStoredShippingRates(storedZip);
		  if (cachedRates) {
				renderShippingRates(cachedRates, storedZip);
		  } else {
				calculateShipping();
		  }
		}

	};

	function log (a){
		if(!debug){ return }
		console.log(a);
	};

	var getCookie = function(name) {
		var value = "; " + document.cookie;
		var parts = value.split('; '+name+'=');
		if (parts.length == 2) return parts.pop().split(";").shift();
	};

	var updateCartCookie = function(a) {
		log('changing cart cookie value to: '+a);
		var date = new Date();
		date.setTime(date.getTime()+(14*86400000));
		var expires = '; expires='+date.toGMTString();
		document.cookie = 'cart='+a+expires+'; path=/';
	};

	var resetCartCookie = function(){
		updateCartCookie(cartCookie);
		log(getCookie('cart'));
	};

	var MAX_POLL_ATTEMPTS = 5;
	var POLL_DELAY = 1500;

	function calculateShipping() {
		if (isCalculating) return;

		var zipCode = shippingZip.value;
		if (!ZipCodeManager.isValidZipCode(zipCode)) return;
		if (!productSelect.value || !productSelect.value.length) return;

		var cachedRates = ZipCodeManager.getStoredShippingRates(zipCode);
		if (cachedRates && cachedRates.shipping_rates && cachedRates.shipping_rates.length > 0) {
			renderShippingRates(cachedRates, zipCode);
			return;
		}

		isCalculating = true;

		var calcButton = document.querySelector('.shippingCalcButton');
		if (calcButton) {
			calcButton.innerText = 'Calculating...';
			calcButton.className = 'button shippingCalcButton disabled';
		}

		var userState = ZipCodeManager.getStoredState() || 'California';

		cartCookie = getCookie('cart');
		var tempCookieValue = "temp-cart-cookie___" + Date.now();
		var fakeCookieValue = "fake-cart-cookie___" + Date.now();

		if (!cartCookie) {
			updateCartCookie(tempCookieValue);
			cartCookie = getCookie('cart');
		}

		if (!cartCookie || cartCookie.length < 32) {
			isCalculating = false;
			resetCalcButton();
			return;
		}

		updateCartCookie(fakeCookieValue);

		var variantId = parseInt(productSelect.value);
		var productQuantity = document.querySelector('.quantity__input');
		var quantity = productQuantity ? parseInt(productQuantity.value) : 1;

		var rateParams = new URLSearchParams({
			'shipping_address[country]': shippingCountry.value,
			'shipping_address[province]': userState,
			'shipping_address[zip]': zipCode
		});

		fetch('/cart/add.js', {
			body: JSON.stringify({ id: variantId, quantity: quantity }),
			credentials: 'same-origin',
			headers: {
				'Content-Type': 'application/json',
				'X-Requested-With': 'xmlhttprequest'
			},
			method: 'POST'
		})
		.then(function(response) { return response.json(); })
		.then(function() {
			// Add once, then poll the SAME cart until carrier service responds
			function pollRates(attempt) {
				return fetch('/cart/shipping_rates.json?' + rateParams, {
					credentials: 'same-origin'
				})
				.then(function(response) { return response.json(); })
				.then(function(result) {
					var hasRates = result.shipping_rates && result.shipping_rates.length > 0;
					if (!hasRates && attempt < MAX_POLL_ATTEMPTS) {
						return new Promise(function(resolve) {
							setTimeout(function() {
								resolve(pollRates(attempt + 1));
							}, POLL_DELAY);
						});
					}
					return result;
				});
			}
			return pollRates(0);
		})
		.then(function(result) {
			if (result.shipping_rates && result.shipping_rates.length > 0) {
				try {
					localStorage.setItem('shipping_rates_v2_' + zipCode, JSON.stringify(result));
				} catch (e) {}
			}
			renderShippingRates(result, zipCode);
		})
		.catch(function(err) {
			console.error('Shipping calculation error:', err);
			shippingMessage.innerHTML = '';
		})
		.then(function() {
			resetCartCookie();
			isCalculating = false;
			resetCalcButton();
		});
	}

	function resetCalcButton() {
		var calcButton = document.querySelector('.shippingCalcButton');
		if (calcButton) {
			calcButton.innerText = 'Calculate';
			calcButton.className = 'button shippingCalcButton';
		}
	}

	var updateGrowingZoneDisplay = function(zone, zipCode) {
		var summaryZip = document.querySelector('.geolocation-growing-zone__summary-zip');
		if (summaryZip && zipCode) {
			summaryZip.textContent = zipCode;
		}

		var summaryZone = document.querySelector('.geolocation-growing-zone__summary-zone');
		if (summaryZone) {
			summaryZone.textContent = zone || '';
		}

		var summaryBottom = document.querySelector('.geolocation-growing-zone__summary-bottom');
		if (summaryBottom) {
			summaryBottom.style.display = zone ? '' : 'none';
		}

		var zipInput = document.querySelector('.geolocation-zip-code');
		if (zipInput && zipCode) {
			zipInput.value = zipCode;
		}

		var resultValue = document.querySelector('.geolocation-growing-zone__result-text-value');
		if (resultValue) {
			resultValue.textContent = zone || '';
		}
	};

	function renderShippingRates(result, zip) {
		var calculatorContainer = document.querySelector('.shopping-calculator');
		if(result.shipping_rates && result.shipping_rates.length){
			if (calculatorContainer) calculatorContainer.classList.remove('shipping-error');
			var messageHtml = '<ul>';
			for (var i = 0; i < result.shipping_rates.length; i++) {
				var element = result.shipping_rates[i];
				var deliveryDays = '';
				if (element.delivery_days && element.delivery_days.length > 0) {
					var minDays = element.delivery_days[0];
					var maxDays = element.delivery_days[1];
					
					if (maxDays && maxDays !== minDays) {
						deliveryDays = '<span>' + minDays + '-' + maxDays + ' days</span>';
					} else if (minDays == 1) {
						deliveryDays = '<span>1 day</span>';
					} else {
						deliveryDays = '<span>' + minDays + ' days</span>';
					}
				}
				if (element.name.includes('Free Shipping')) {
					messageHtml += '<li>' + element.name + '<br>' + deliveryDays + '</li>';
				} else {
					messageHtml += '<li>' + element.name + ' for <b>$' + element.price + '</b><br>' + deliveryDays + '</li>';
				}
			}
			messageHtml += '</ul>';
			shippingMessage.innerHTML = messageHtml;
			resetCalcButton();

			var titleSummary = document.querySelector('.shipping-title-summary');
			if (titleSummary) titleSummary.style.display = 'block';
			if (titleSummary && result.shipping_rates.length > 0) {
				var first = result.shipping_rates[0];
				var days = '';
				if (first.delivery_days && first.delivery_days.length > 0) {
					var minDays = first.delivery_days[0];
					var maxDays = first.delivery_days[1];
					
					if (maxDays && maxDays !== minDays) {
						days = minDays + '-' + maxDays + ' days';
					} else if (minDays == 1) {
						days = '1 day';
					} else {
						days = minDays + ' days';
					}
				}
				var hasShipping = result.shipping_rates.some(function(r) { return r.name.indexOf('Shipping') !== -1; });
				var label = hasShipping ? 'Estimated shipping to' : 'Estimated delivery to';
				titleSummary.innerHTML = label + ' <b>' + zip + '</b>: <b>' + days + '</b>';
			}

		} else {
			if (calculatorContainer) calculatorContainer.classList.add('shipping-error');
			shippingMessage.innerHTML = 'We\'re sorry, but we do not currently deliver to your address. Please call us if you would like to arrange a special delivery';
			resetCalcButton();
			var titleSummary = document.querySelector('.shipping-title-summary');
			if (titleSummary) titleSummary.textContent = 'Your zip code is outside of our normal delivery area';
		}

		window.dispatchEvent(new CustomEvent('shippingRatesReady', {
			detail: { rates: result, zip: zip }
		}));
	}

	initFields();
})()
